import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.baseUrl}/user`,{params:searchParams});
    }

	getUserList(searchParams){
		return this.http.get(`${environment.baseUrl}/user?exclude_role=3`,{params:searchParams});
	  }

    get(id){
      return this.http.get(`${environment.baseUrl}/user/`+id);
    }

    edit(id,formData){
      return this.http.put(`${environment.baseUrl}/user/`+id,formData);
    }

    create(formData){
      return this.http.post(`${environment.baseUrl}/user`,formData);
    }

    delete(id){
      return this.http.delete(`${environment.baseUrl}/user/`+id);
    }

    profile(formData){
      return this.http.post(`${environment.baseUrl}/auth/profile`,formData);
    }

	me(formData){
		return this.http.post(`${environment.baseUrl}/auth/me`,formData);
	  }

}
